<template>
    <a data-toggle="tooltip" :title="title" style="cursor:pointer">
        <slot></slot>
    </a>
</template>
<script>
    import $ from 'jquery';

    export default {
        props: ['title'],
        mounted: function () {
            $(this.$el).tooltip();
        }
        , watch: {
            title() {
                $(this.$el).tooltip('destroy')
                $(this.$el).tooltip();
            }
        },
        destroyed() {
            $(this.$el).tooltip('destroy')
        }
    }
</script>


// WEBPACK FOOTER //
// tooltipcontrol.scp.html?208f8ac7